import { useQuery } from '@apollo/client/react';

import { getParsedQuery, getScrapedQuery } from '../../services/DocumentService';

const documentObject = (document, text) => {
  const link = document.link;
  const fileName = link.split('/').pop().split('?')[0];

  return { link, linkKey: fileName, show: text };
};

export const usePaymentDocuments = (parsedDocumentExtId, scrapedDocumentExtId) => {
  const {
    data: parsedData,
    loading: parsedLoading,
    error: parsedError
  } = useQuery(getParsedQuery, {
    skip: !parsedDocumentExtId,
    variables: { filter: { ids: [parsedDocumentExtId] } }
  });
  const {
    data: scrapedData,
    loading: scrapedLoading,
    error: scrapedError
  } = useQuery(getScrapedQuery, {
    skip: !scrapedDocumentExtId,
    variables: { id: scrapedDocumentExtId }
  });

  const scrapedDocument = scrapedData?.document;
  const relatedDocumentId = scrapedDocument?.requiresTransformation
    ? scrapedDocument.relatedDocumentId
    : null;
  const {
    data: relatedData,
    loading: relatedLoading,
    error: relatedError
  } = useQuery(getScrapedQuery, {
    skip: !relatedDocumentId,
    variables: { id: relatedDocumentId }
  });

  const documents = [];
  const parsedDocument = parsedData?.document?.[0];
  if (parsedDocument) {
    documents.push(documentObject(parsedDocument, 'Documento parseado'));
  }

  const documentToShow = scrapedDocument?.requiresTransformation
    ? relatedData?.document
    : scrapedDocument;
  if (documentToShow) {
    documents.push(
      documentObject(
        documentToShow,
        scrapedDocument.requiresTransformation ? 'Documento transformado' : 'Documento original'
      )
    );
  }

  return {
    documents,
    loading: parsedLoading || scrapedLoading || relatedLoading,
    error: parsedError || scrapedError || relatedError
  };
};
